import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Entidad } from 'src/app/models/Entidad';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
import { isNotEmpty } from 'src/app/general/variables';
// import { MfuncErrorVal } from 'src/app/general/variables';
// import { ErrorValidator } from 'src/app/models/personalizados/ErrorValidator';

@Component({
  selector: 'app-busq-entidad',
  templateUrl: './busq-entidad.component.html',
  styleUrls: ['./busq-entidad.component.css']
})
export class BusqEntidadComponent implements OnInit {

  entidades: Entidad[] = [];
  // mFuncErrorVal : MfuncErrorVal = new MfuncErrorVal();
  // errorValidator: ErrorValidator[] = [];
  strCodEntidad = '';
  strDscEntidad = '';
  numIdComponente = 1;
  flgLectura = false;

  @Output() setCodEntidadOut = new EventEmitter();

  constructor(
    protected entidadService: EntidadService) { }

  ngOnInit() {
  }

  setModoLectura(flgValor: boolean) {

    this.flgLectura = flgValor;

  }

  _buscarEntidad(valor) {

    // console.log("==============_buscarEntidad");

    const vNombreEntidad = valor.target.value;

    this.strDscEntidad = vNombreEntidad;
    // console.log("===========nombreEntidad");
    // console.log(nombreEntidad);

    if (valor.target.value.length >= 4) {

      this.entidadService.obtenerEntidadesXNombre(vNombreEntidad).subscribe(data => {

          data = data.slice( 0, 20 );

          this.entidades = data;

          // console.log("===========this.entidades");
          // console.log(this.entidades);

      });
    }
  }

  _seleccionarEntidad(strEntidad) {

    // console.log("==============_seleccionarEntidad");
    // console.log(this.strDscEntidad);

    // let name = event.target.value;
    const name = strEntidad;


    // console.log("==============name");
    // console.log(name);

    // console.log("==============NATES DE INGRESAR");

    this._llenarCombosEntidad(name);

    // console.log("==============NDESPUES DE INGRESAR");

    this.entidades = [];
  }

  _llenarCombosEntidad(nombreEntidad: string) {

    // console.log("==============_llenarCombosEntidad");

    let vCodEntidad = '';

    // console.log("=============nombreEntidad");
    // console.log(nombreEntidad);
    // console.log(this.entidades);

    if (this.entidades != null) {

      // console.log("==============_llenarCombosEntidad11111111111");

      // console.log("==============this.entidades");
      // console.log(this.entidades);
      // console.log(nombreEntidad);

      const entidad = this.entidades.filter(x => x.centNombre === nombreEntidad)[0];

      // console.log(entidad);

      if (entidad != null) {

        // console.log("==============_llenarCombosEntidad2222222222222");

        vCodEntidad = entidad.centCodigo;

        this.strCodEntidad = vCodEntidad;
        this.strDscEntidad = nombreEntidad;

        this.entidadService.obtenerEntidadXCodigo(vCodEntidad).subscribe(data => {

          // console.log("==============_llenarCombosEntidad3333333333333");

          this._emitirDatos(data);

          // this.setCodEntidadOut.emit(data);
          // this.setCodEntidadRemitOut.emit(data);

          // console.log("===========this.entidades");
          // console.log(this.entidades);

        });



      }
    }

  }

  _emitirDatos(data: Entidad) {

    // console.log("==============_emitirDatos");

    this.setCodEntidadOut.emit(data);

  }

  getCodEntidad() {


    return this.strCodEntidad;

  }

  setNumIdComponente(idComponente: number) {
    this.numIdComponente = idComponente;
  }

  setEntidad(codEntidad: string, flgEmit: boolean) {

    const vDscControl = 'input_busq_' + this.numIdComponente.toString();

    this.strDscEntidad = '';
    this.strCodEntidad = '';

    (document.getElementById(vDscControl) as HTMLInputElement).value = '';

    this.entidades = [];

    if (isNotEmpty(codEntidad)) {

      this.entidadService.obtenerEntidadXCodigo(codEntidad).subscribe(data => {

        if (data != null) {

          this.strDscEntidad = data.centNombre;
          this.strCodEntidad = data.centCodigo;

          this.entidades.push(data);

          // console.log("========data");
          // console.log(data);

          // this.setCodEntidadOut.emit(data);
          if (flgEmit) {this._emitirDatos(data); }

        }


      });

    }

  }

  // ValidarDatos(numPosError:number)
  // {

  //   //var FlgError = false;

  //   this.errorValidator = this.mFuncErrorVal.AgregarErrorValIndex((this.strCodEntidad.length > 0 ? false:true), "Ingrese la entidad",this.errorValidator,numPosError);

  //   // if(this.mFuncErrorVal.RevisarErrorValidator(this.errorValidator))
  //   // {

  //   //   FlgError = true

  //   // }

  //   return this.errorValidator;

  // }

}
